import React, { useState } from "react"
import Header from "./header"
import Footer from "./footer"
import "./style.css"
import YourFaultVideo from "../../resources/your_fault.mp4"

const Index = () => {
	const [nav, showNav] = useState(false)

	return (
		<div style={{ display: "flex", flexDirection: "column" }}>
			<Header style={{ alignItems: "flex-start" }}>
			</Header >
			<video loop autoPlay muted style={{ preload: 'auto', height: "75vh", objectFit: "cover", display: "block", margin: "0 auto", alignItems: "stretch" }}>
				<source src={YourFaultVideo} type="video/mp4" />
			</video>
			<Footer style={{ alignItems: "flex-end" }}>
			</Footer>
		</div>
	)
}

export default Index
